import gql from 'graphql-tag';

export const UPDATE_DEFAULT_DEEPLINK = gql`
         mutation UpdateDefaultDeeplink($data: UpdateDefaultDeeplinkInput!) {
           updateDefaultDeeplinkMutation(data: $data)
         }
       `;
